'use strict';

module.exports = {
    keyupHandler: function keyupHandler(e, cb) {
        if (e.keyCode === 32 || e.keyCode === 13) {
            e.preventDefault();
            e.stopPropagation();
            e.currentTarget.click();
            if (typeof cb === 'function') cb();
        }
    },
    focusOnElementAfterModalTransition: function focusOnElementAfterModalTransition(id, closeOrOpen) {
        var modalState = {
            open: 'shown.bs.modal',
            close: 'hidden.bs.modal'
        };
        $('#generic-modal').one(modalState[closeOrOpen], function () {
            $(id).focus();
        });
    },
    keepTrappedInModal: function keepTrappedInModal(e, $first, $last, allowDefault, allowPropagation) {
        if (e.keyCode === 9) {
            if (e.target === $first && e.shiftKey) {
                if (!allowDefault) e.preventDefault();
                if (!allowPropagation) e.stopPropagation();
                $last.focus();
            } else if (e.target === $last && !e.shiftKey) {
                if (!allowDefault) e.preventDefault();
                if (!allowPropagation) e.stopPropagation();
                $first.focus();
            }
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/ADAHelpers.js
// module id = 21
// module chunks = 0